/**
 * agentService — Client for the workflow-planning AI agent.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const agentService = {
  async listTools() {
    const res = await axios.get(`${API}/tools`);
    return res.data;
  },

  /**
   * Generate a workflow plan.
   * @param {object} args
   * @param {string} args.goal
   * @param {object} [args.provided_inputs]
   * @param {string} [args.provider]
   * @param {string} [args.model]
   * @param {string} [args.session_id]
   */
  async planWorkflow(args) {
    const res = await axios.post(`${API}/agent/workflow-plan`, args);
    return res.data;
  },

  /**
   * Refine an existing plan.
   * @param {object} args
   * @param {object} args.plan
   * @param {string} args.instruction
   * @param {string} [args.provider]
   * @param {string} [args.model]
   * @param {string} [args.session_id]
   */
  async refineWorkflow(args) {
    const res = await axios.post(`${API}/agent/refine`, args);
    return res.data;
  },
};

export default agentService;
